import {
  NormalMultipleFixedInputFields,
  NormalTextInputField,
} from "@/components";
import { useMemo } from "react";

const HomeWCUSectionFormField = ({
  activeLang,
  isFetching,
  allFilesResponse,
  searchValue,
  selectedFileType,
  onChangeImage,
  handleTextInputChange,
  handleTextEditorInputChange,
  stateDetails,
  adminRole,
  permissionsList,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeLang === "en";
  }, [activeLang]);

  return (
    <>
      {/* Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Heading"
        fieldId="home-section-3-wcu-heading"
        fieldName="home-section-3-wcu-heading"
        placeholderText="Heading"
        inputValue={stateDetails?.["home-section-3-wcu-heading"] || ""}
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
      />

      {/* Sub Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        isTextArea={true}
        labelText="Sub Heading"
        fieldId="home-section-3-wcu-sub-heading"
        fieldName="home-section-3-wcu-sub-heading"
        placeholderText="Sub Heading"
        inputValue={stateDetails?.["home-section-3-wcu-sub-heading"] || ""}
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mt-5"
        translateField={true}
      />

      {/* WCU Images */}
      <NormalMultipleFixedInputFields
        stateDetails={stateDetails}
        isFetching={isFetching}
        allFilesResponse={allFilesResponse}
        labelText="WCU Images"
        fieldId="home-section-3-wcu-images"
        searchValue={searchValue}
        selectedFileType={selectedFileType}
        adminRole={adminRole}
        permissionsList={permissionsList}
        handleImageChange={onChangeImage}
        handleTextInputChange={handleTextInputChange}
        translateField={true}
        extraContainerClasses="mt-5"
        cards={[
          {
            card_id: "home-section-3-wcu-card-1",
            types: ["IMAGE", "TEXT_AREA"],
            is_hidden: [isHideInOtherLanguages, true],
            ids_name: ["image_field_id", "text_field_id"],
            placeholders_name: ["", "textarea_input_placeholder"],
            image_field_id: "home-section-3-wcu-image-1",
            text_field_id: "home-section-3-wcu-text-1",
            textarea_input_placeholder: "Image 1 Text",
          },
          {
            card_id: "home-section-3-wcu-card-2",
            types: ["IMAGE", "TEXT_AREA"],
            is_hidden: [isHideInOtherLanguages, true],
            ids_name: ["image_field_id", "text_field_id"],
            placeholders_name: ["", "textarea_input_placeholder"],
            image_field_id: "home-section-3-wcu-image-2",
            text_field_id: "home-section-3-wcu-text-2",
            textarea_input_placeholder: "Image 2 Text",
          },
          {
            card_id: "home-section-3-wcu-card-3",
            types: ["IMAGE", "TEXT_AREA"],
            is_hidden: [isHideInOtherLanguages, true],
            ids_name: ["image_field_id", "text_field_id"],
            placeholders_name: ["", "textarea_input_placeholder"],
            image_field_id: "home-section-3-wcu-image-3",
            text_field_id: "home-section-3-wcu-text-3",
            textarea_input_placeholder: "Image 3 Text",
          },
          {
            card_id: "home-section-3-wcu-card-4",
            types: ["IMAGE", "TEXT_AREA"],
            is_hidden: [isHideInOtherLanguages, true],
            ids_name: ["image_field_id", "text_field_id"],
            placeholders_name: ["", "textarea_input_placeholder"],
            image_field_id: "home-section-3-wcu-image-4",
            text_field_id: "home-section-3-wcu-text-4",
            textarea_input_placeholder: "Image 4 Text",
          },
          {
            card_id: "home-section-3-wcu-card-5",
            types: ["IMAGE", "TEXT_AREA"],
            is_hidden: [isHideInOtherLanguages, true],
            ids_name: ["image_field_id", "text_field_id"],
            placeholders_name: ["", "textarea_input_placeholder"],
            image_field_id: "home-section-3-wcu-image-5",
            text_field_id: "home-section-3-wcu-text-5",
            textarea_input_placeholder: "Image 5 Text",
          },
        ]}
      />
    </>
  );
};

export default HomeWCUSectionFormField;
